import { trpc } from "lib/trpc";
import { ClientFileList } from "@compass/shared/types";

export const useBenchmark = (input: ClientFileList) => {
    const query = trpc.clientFiles.latest.useQuery(input, {
        placeholderData: (prev) => prev,
    });

    const { data, isInitialLoading } = query;
    const nothingFound = Boolean(!isInitialLoading && !data?.reports.length);

    return { ...query, nothingFound };
};
